/*@flow*/
import { useEffect } from 'react';
import * as log from 'lib/log';

export default function useError(err: any) {
  useEffect(() => {
    if (!err) return;
    log.error(err);
  }, [err]);
}
